import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const TimeoutModal = ({ open, onClose, onExtend, countdown }) => {
  const { t: translate } = useTranslation();

  const buttonStyle = {
    height: '36px',
    backgroundColor: '#EF5350',
    color: 'white',
    '&:hover': {
      backgroundColor: '#E53935',
    },
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    flex: 1,
  };

  const outlineButtonStyle = {
    height: '36px',
    borderColor: '#d32f2f',
    color: '#d32f2f',
    '&:hover': {
      borderColor: '#d32f2f',
      backgroundColor: 'transparent',
    },
    textTransform: 'none',
    fontSize: '13px',
    fontWeight: 500,
    flex: 1,
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 1,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pb: 1,
        }}
      ></DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            py: 1,
          }}
        >
          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              mb: 1,
              fontSize: '0.875rem',
            }}
          >
            {translate('session.timeout.message', { countdown })}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          px: 2,
          pb: 2,
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <Button onClick={onClose} variant="outlined" color="error" size="small" sx={outlineButtonStyle}>
          {translate('common.logout')}
        </Button>
        <Button onClick={onExtend} variant="contained" color="primary" size="small" sx={buttonStyle}>
          {translate('session.timeout.extend')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimeoutModal;
